import Swiper from 'swiper/bundle';

const getSwiperA11yMessages = () => {
	const locale = window.Shopify?.locale || document.documentElement.lang || 'uk';
	const isUk = locale === 'uk';

	return {
		enabled: true,
		slideLabelMessage: '',
		paginationBulletMessage: isUk ? 'Перейти до слайду {{index}}' : 'Перейти к слайду {{index}}',
		nextSlideMessage: isUk ? 'Наступний слайд' : 'Следующий слайд',
		prevSlideMessage: isUk ? 'Попередній слайд' : 'Предыдущий слайд',
	};
};

const classes = {
	deviceCardSelector: '.device-card',
	swatchItemSelector: '.swatches__item',
	swatchLinkSelector: '.swatches__link',
	imageSelector: '.device-card__img',
	priceSelector: '.device-card__price',
	buyButtonSelector: '.js-add-to-cart',
	activeSwatchClass: 'is-active',
	activeImageClass: 'is-visible',
	sectionGridSelector: '.compatible-devices__grid',
	paginationSelector: '.compatible-devices .slider-pagination',
	prevButtonSelector: '.compatible-devices .slider-controls__btn--prev',
	nextButtonSelector: '.compatible-devices .slider-controls__btn--next'
};

function setActiveState(collection, activeClass, activeIndex) {
	collection.forEach((item, index) => {
		item.classList.toggle(activeClass, index === activeIndex);
	});
}

function updateBuyButton(card, swatch) {
	const buyButton = card.querySelector(classes.buyButtonSelector);
	if (!buyButton || !swatch) {
		return;
	}

	const variantId = swatch.getAttribute('data-variant-id') || '';
	const isAvailable = swatch.getAttribute('data-available') === 'true';

	if (variantId) {
		buyButton.setAttribute('data-variant-id', variantId);
	} else {
		buyButton.removeAttribute('data-variant-id');
	}

	buyButton.classList.toggle('btn--disabled', !isAvailable);
	if (isAvailable) {
		buyButton.removeAttribute('disabled');
	} else {
		buyButton.setAttribute('disabled', 'disabled');
	}
}

function updatePrice(card, swatch) {
	const priceEl = card.querySelector(classes.priceSelector);
	if (!priceEl || !swatch) {
		return;
	}

	const price = swatch.getAttribute('data-price') || '';
	if (price) {
		priceEl.textContent = price;
	}
}

function updateCard(card, index) {
	const swatchItems = Array.from(card.querySelectorAll(classes.swatchItemSelector));
	const swatches = swatchItems
		.map((item) => item.querySelector(classes.swatchLinkSelector))
		.filter(Boolean);
	const images = Array.from(card.querySelectorAll(classes.imageSelector));

	if (!swatches.length) {
		return;
	}

	const safeIndex = Math.max(0, Math.min(index, swatches.length - 1));
	const activeSwatch = swatches[safeIndex];

	setActiveState(swatchItems, classes.activeSwatchClass, safeIndex);
	setActiveState(images, classes.activeImageClass, safeIndex);
	updateBuyButton(card, activeSwatch);
	updatePrice(card, activeSwatch);
}

function initCard(card) {
	const swatchItems = Array.from(card.querySelectorAll(classes.swatchItemSelector));
	const swatches = swatchItems
		.map((item) => item.querySelector(classes.swatchLinkSelector))
		.filter(Boolean);

	if (!swatches.length) {
		return;
	}

	swatches.forEach((swatch, index) => {
		swatch.addEventListener('click', () => {
			updateCard(card, index);
		});
	});

	const initialIndex = swatchItems.findIndex((item) => item.classList.contains(classes.activeSwatchClass));
	updateCard(card, initialIndex >= 0 ? initialIndex : 0);
}

function initDeviceCards(root) {
	const cards = Array.from(root.querySelectorAll(classes.deviceCardSelector));
	if (!cards.length) {
		return;
	}

	cards.forEach((card) => {
		initCard(card);
	});
}

function initSlider(sliderEl) {
	new Swiper(sliderEl, {
		loop: true,
		speed: 500,
		slidesPerView: 4,
		spaceBetween: 24,
		
		pagination: {
			el: classes.paginationSelector,
			bulletClass: 'slider-pagination__bullet',
			bulletActiveClass: 'slider-pagination__bullet--active',
			clickable: true
		},
		navigation: {
			prevEl: classes.prevButtonSelector,
			nextEl: classes.nextButtonSelector,
		},
		a11y: getSwiperA11yMessages(),

		breakpoints: {
			100: {
				slidesPerView: 1.2,
				spaceBetween: 10
			},
			350: {
				slidesPerView: 1.25,
				spaceBetween: 16
			},
			650: {
				slidesPerView: 2,
				spaceBetween: 16
			},
			900: {
				slidesPerView: 2,
				spaceBetween: 24
			},
			
			// 1024: {
			// 	slidesPerView: 2,
			// 	spaceBetween: 24
			// },
			
		},
	});
}

export function initCompatibleDevices() {
	const sliderEl = document.querySelector(classes.sectionGridSelector);
	if (!sliderEl) {
		return;
	}

	initSlider(sliderEl);
	initDeviceCards(sliderEl);
}

export function compatibleDevices() {
	initCompatibleDevices();
}
